import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycHowDoYouEnsureThatFundsAreNotMisusedInATrustPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-how-do-you-ensure-that-funds-are-not-misused-in-a-trust/']} />;
}
